// Utilitário para detectar dispositivos móveis e sistema operacional

export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};

export const getOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }
  
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  return 'unknown';
};

export const getAppStoreUrl = (os) => {
  const urls = {
    ios: 'https://apps.apple.com/br/app/cosmoclube/id6743984433',
    android: 'https://play.google.com/store/apps/details?id=com.astronalia.cosmoclube'
  };
  
  return urls[os] || urls.android;
};

export const getNativeAppStoreUrl = (os) => {
  const nativeUrls = {
    ios: 'itms-apps://apps.apple.com/br/app/cosmoclube/id6743984433',
    android: 'market://details?id=com.astronalia.cosmoclube'
  };
  
  return nativeUrls[os] || nativeUrls.android;
};

export const getAppDeepLink = (os) => {
  const deepLinks = {
    ios: 'cosmoclube://',
    android: 'cosmoclube://'
  };
  
  return deepLinks[os] || deepLinks.android;
};

export const openApp = (os, path = '') => {
  const nativeStoreUrl = getNativeAppStoreUrl(os);
  const fallbackStoreUrl = getAppStoreUrl(os);
  
  console.log(`Tentando abrir app nativo da store: ${nativeStoreUrl}`);
  
  if (os === 'ios') {
    // Para iOS, tenta abrir o App Store nativo primeiro
    const timeout = setTimeout(() => {
      console.log('Timeout atingido, abrindo no navegador');
      window.open(fallbackStoreUrl, '_blank');
    }, 1000);
    
    try {
      window.location.href = nativeStoreUrl;
      // Se conseguiu redirecionar, cancela o timeout
      clearTimeout(timeout);
    } catch (e) {
      clearTimeout(timeout);
      console.warn('Erro ao tentar abrir App Store nativo, usando fallback:', e);
      window.open(fallbackStoreUrl, '_blank');
    }
  } else if (os === 'android') {
    // Para Android, tenta múltiplas abordagens
    let appOpened = false;
    
    // Primeira tentativa: Intent URL para abrir Google Play
    try {
      const intent = `intent://details?id=com.astronalia.cosmoclube#Intent;scheme=market;package=com.android.vending;end`;
      window.location.href = intent;
      appOpened = true;
    } catch (e) {
      console.warn('Intent URL falhou:', e);
    }
    
    // Se o intent falhou, tenta o market:// URL
    if (!appOpened) {
      try {
        window.location.href = nativeStoreUrl;
        appOpened = true;
      } catch (e) {
        console.warn('Market URL falhou:', e);
      }
    }
    
    // Fallback para navegador se nada funcionou
    if (!appOpened) {
      setTimeout(() => {
        console.log('Todos os métodos nativos falharam, abrindo no navegador');
        window.open(fallbackStoreUrl, '_blank');
      }, 500);
    }
  } else {
    // Fallback para outros sistemas
    window.open(fallbackStoreUrl, '_blank');
  }
};

// Tenta abrir o app no path especificado; sem fallback para store (ex: reset de senha)
export const tryOpenApp = (path = '') => {
  const os = getOperatingSystem();
  if (os === 'unknown') return;

  const cleanPath = path.replace(/^\//, '');
  window.location.href = `cosmoclube://${cleanPath}`;
  // Sem fallback — usuário permanece na página se o app não estiver instalado
};

// Tenta abrir o app no path especificado; se não estiver instalado redireciona para a store
export const openAppOrStore = (path = '') => {
  const os = getOperatingSystem();
  if (os === 'unknown') return;

  const cleanPath = path.replace(/^\//, '');
  const deepLink = `cosmoclube://${cleanPath}`;
  const storeUrl = getAppStoreUrl(os);

  window.location.href = deepLink;

  setTimeout(() => {
    if (!document.hidden) {
      window.location.href = storeUrl;
    }
  }, 1500);
};

// Função para abrir conteúdo específico
export const openAppWithContent = (contentType, contentId) => {
  const os = getOperatingSystem();
  const path = `${contentType}/${contentId}`;
  openApp(os, path);
};

// Função para testar se o app está instalado (Android apenas)
export const testAppInstallation = async () => {
  const os = getOperatingSystem();
  
  if (os === 'android') {
    try {
      // Tenta usar o intent do Android
      const intentUrl = `intent://cosmoclube.com#Intent;scheme=cosmoclube;package=com.astronalia.cosmoclube;end`;
      window.location.href = intentUrl;
      return true;
    } catch (e) {
      console.log('App não está instalado');
      return false;
    }
  }
  
  return false; // Para iOS não conseguimos detectar facilmente
};
